import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';
import { Content } from 'pages/Content/Content';
import { ContentCreatePage } from './ContentCreatePage';
import { ContentEditPage } from './ContentEditPage';
import { ContentDetailPage } from './ContentDetailPage';
import AuthRoute from 'containers/AuthRoute';
import { EUserType } from 'services/BackendApi';

export interface ContentMarketingRoutingProps extends RouteComponentProps {}

export const ContentMarketingRouting = (props: ContentMarketingRoutingProps) => {
  return (
    <Switch>
      <AuthRoute
        allow={[EUserType.ADMIN, EUserType.MARKETING]}
        path={`${props.match.path}/edit/:contentUuid`}
        component={ContentEditPage}
        exact
      />
      <AuthRoute
        allow={[EUserType.ADMIN, EUserType.MARKETING]}
        path={`${props.match.path}/create`}
        component={ContentCreatePage}
        exact
      />
      <AuthRoute
        allow={[EUserType.ADMIN, EUserType.MARKETING]}
        path={`${props.match.path}/`}
        component={Content}
        exact
      />
      <AuthRoute
        allow={[EUserType.ADMIN, EUserType.MARKETING, EUserType.SR, EUserType.TA]}
        path={`${props.match.path}/:contentUuid`}
        component={ContentDetailPage}
        exact
      />
    </Switch>
  );
};

export const ContentMarketingRoutingWithRouter = compose(withRouter)(ContentMarketingRouting);
